import { useMemo, useState } from "react";
import { tvShows } from "@/mocks/movies";

const tabs = ["国产剧", "美剧", "韩剧"];

export default function TvSection() {
  const [tab, setTab] = useState(tabs[0]);

  const list = useMemo(() => tvShows.filter((t) => t.tab === tab), [tab]);

  return (
    <section id="tv" className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            电视剧大全
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-2xl leading-relaxed">
            按产地分类整理热播与完结剧集，国产剧、美剧、韩剧一键切换，
            每部剧集标注更新进度、题材与评分，追更不再需要四处翻找。
          </p>
        </div>
        <div
          className="inline-flex w-fit items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200"
          role="tablist"
          aria-label="剧集分类"
        >
          {tabs.map((t) => {
            const isActive = t === tab;
            return (
              <button
                key={t}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setTab(t)}
                className={`px-4 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer ${
                  isActive
                    ? "bg-secondary-600 text-background-50 font-semibold"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {t}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {list.map((item) => (
          <article
            key={item.id}
            className="flex gap-4 rounded-xl bg-background-100 border border-background-200 p-4"
          >
            <div className="w-24 sm:w-28 shrink-0 aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src={item.poster}
                alt={`${item.title} 剧集海报`}
                title={`${item.title} 在线观看 - 八戒影院`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex flex-col min-w-0">
              <h3 className="text-base font-semibold text-foreground-950 line-clamp-1">
                {item.title}
              </h3>
              <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
                <span className="px-2 py-0.5 rounded bg-accent-100 text-accent-800">
                  {item.genre}
                </span>
                <span>{item.region}</span>
                <span>{item.year}</span>
              </div>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-3">
                {item.desc}
              </p>
              <div className="mt-auto pt-3 flex items-center justify-between">
                <span className="text-xs font-medium text-primary-700">{item.episodes}</span>
                <span className="text-xs font-bold text-foreground-800 flex items-center gap-1">
                  <i className="ri-star-fill text-primary-500 text-xs" aria-hidden="true" />
                  {item.rating}
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>

      <p className="mt-6 text-xs text-foreground-500">
        「{tab}」当前收录 {list.length} 部，全站剧集共 {tvShows.length} 部。
      </p>
    </section>
  );
}